'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REMOVE_CONTENT = exports.EDIT_ITEM = exports.ADD_CONTENT = exports.REMOVE_RATING = exports.EDIT_RATING = exports.ADD_RATING = exports.RATINGS = undefined;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RATINGS = exports.RATINGS = _constantsAnalytics2.default.CATEGORIES.RATINGS;
var _analyticsConstants$E = _constantsAnalytics2.default.EVENTS;
var ADD_RATING = _analyticsConstants$E.ADD_RATING,
    EDIT_RATING = _analyticsConstants$E.EDIT_RATING,
    REMOVE_RATING = _analyticsConstants$E.REMOVE_RATING;
exports.ADD_RATING = ADD_RATING;
exports.EDIT_RATING = EDIT_RATING;
exports.REMOVE_RATING = REMOVE_RATING;
var _analyticsConstants$A = _constantsAnalytics2.default.ACTIONS;
var ADD_CONTENT = _analyticsConstants$A.ADD_CONTENT,
    EDIT_ITEM = _analyticsConstants$A.EDIT_ITEM,
    REMOVE_CONTENT = _analyticsConstants$A.REMOVE_CONTENT;

/**
 * @param {string} ratingValue rating is based out of 10/100; ie 10, 30, 70 are valid values
 */

exports.ADD_CONTENT = ADD_CONTENT;
exports.EDIT_ITEM = EDIT_ITEM;
exports.REMOVE_CONTENT = REMOVE_CONTENT;
function composeRatingEvent(eventName, ratingValue, action) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: 1,
    gtmLabel: ratingValue,
    gtmCategory: RATINGS,
    gtmAction: action
  });
}

function composeAddRatingEvent(ratingValue) {
  return (0, _compose.composeAnalytics)([composeRatingEvent(ADD_RATING, ratingValue, ADD_CONTENT)]);
}

function composeEditRatingEvent(ratingValue) {
  return (0, _compose.composeAnalytics)([composeRatingEvent(EDIT_RATING, ratingValue, EDIT_ITEM)]);
}

function composeRemoveRatingEvent() {
  return (0, _compose.composeAnalytics)([composeRatingEvent(REMOVE_RATING, undefined, REMOVE_CONTENT)]);
}

exports.default = {
  composeAddRatingEvent: composeAddRatingEvent,
  composeEditRatingEvent: composeEditRatingEvent,
  composeRemoveRatingEvent: composeRemoveRatingEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/ratingsEventComposer.js
// module id = 585
// module chunks = 0 2 4 5 6 8 9 10 11